import { number, ord, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { LoyaltyProgramType } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { createHandler, Optional } from '@mews/std';

export interface SortableLoyaltyItem {
    programName: string;
    programType: LoyaltyProgramType;
    tierOrdering: number;
}

const handleProgramTypeOrdering = createHandler<LoyaltyProgramType, number>(
    {
        [LoyaltyProgramType.Hotel]: 0,
        [LoyaltyProgramType.ExternalPartner]: 1,
        [LoyaltyProgramType.SoftBrand]: 2,
    },
    3
);

const programNameContramap = pipe(
    string.Ord,
    ord.contramap((item: SortableLoyaltyItem) => item.programName)
);

const programTypeOrderingContramap = pipe(
    number.Ord,
    ord.contramap((item: SortableLoyaltyItem) => handleProgramTypeOrdering(item.programType))
);

const tierOrderingContramap = pipe(
    number.Ord,
    ord.contramap((item: SortableLoyaltyItem) => item.tierOrdering)
);

export const loyaltySortingOrds = [programTypeOrderingContramap, tierOrderingContramap, programNameContramap];

interface GetLoyaltyMembershipNameParams {
    programName: string;
    tierName: Optional<string>;
}

export const getLoyaltyMembershipName = ({ programName, tierName }: GetLoyaltyMembershipNameParams) =>
    tierName ? `${programName}${UnicodeEntity.NoBreakSpace}${tierName}` : programName;
